import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css"; // Importer les styles par défaut de Swiper

import "./Caroussel.css";

function Caroussel() {
  return (
    <div className="Caroussel">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000 }}
        loop={true}
      >
        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/63nhZ0HL/A.png" alt="Property 2" />
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/zGvS75tf/B.png" alt="Property 3" />
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/KvJDt45V/C.png" alt="Property 4" />
          </div>
        </SwiperSlide>
       
        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/7ZR1Qcdn/E.png" alt="Property 4" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/DwsD1Yc8/F.png" alt="Property 4" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/YC1nvLpF/G.png" alt="Property 4" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">
            <img src="https://i.postimg.cc/9fCxZXMn/H.png" alt="Property 4" />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Caroussel;
